<template>
  <div class="LCoronaWidgetNew">
    <div class="LCoronaWidgetNew__header">
      <div class="LCoronaWidgetNew__headline">
        Koronavirusas Lietuvoje
      </div>
      <a href="https://plus.lrytas.lt/koronavirusas/" target="_blank" class="LCoronaWidgetNew__button">
        Sužinokite Daugiau
      </a>
    </div>
    <div class="LCoronaWidgetNew__row">
      <div class="LCoronaWidgetNew__col">
        <div class="LCoronaWidgetNew__title">
          Praėjusią parą <br>užsikrėtusių:
        </div>
        <div class="LCoronaWidgetNew__number">
          {{ contaminated }}
        </div>
      </div>
      <div class="LCoronaWidgetNew__col">
        <div class="LCoronaWidgetNew__title">
          Praėjusią parą <br>mirusių:
        </div>
        <div class="LCoronaWidgetNew__number LCoronaWidgetNew__number--red">
          {{ deaths }}
        </div>
      </div>
    </div>
    <div class="LCoronaWidgetNew__row">
      <div class="LCoronaWidgetNew__col">
        <div class="LCoronaWidgetNew__title">
          Pilnai paskiepytų <br>žmonių:
        </div>
        <div class="LCoronaWidgetNew__number">
          {{ vaccinated.toLocaleString('lt-LT') }}
        </div>
      </div>
      <div class="LCoronaWidgetNew__col">
        <div class="LCoronaWidgetNew__title">
          Paskiepytos Lietuvos <br>populiacijos dalis:
        </div>
        <div class="LCoronaWidgetNew__number">
          {{ vaccinatedPercent }}%
        </div>
      </div>
      <div class="LCoronaWidgetNew__bottom">
        <a href="https://plus.lrytas.lt/koronavirusas/" target="_blank" class="LCoronaWidgetNew__button LCoronaWidgetNew__button--mobile">
          Sužinokite Daugiau
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LCoronaWidgetNew',
  data () {
    return {
      apiUrl: 'https://api.lrytas.lt/coronavirus/api/widget-new',
      contaminated: 0,
      deaths: 0,
      vaccinated: 0,
      vaccinatedPercent: 0,
      population: 2794000
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      fetch(this.apiUrl)
        .then((response) => {
          response
            .json()
            .then((data) => {
              if (data) {
                this.contaminated = data.contaminated
                this.deaths = data.died
                this.vaccinated = data.vaccinated
                this.vaccinatedPercent = ((this.vaccinated / this.population) * 100).toFixed(2)
              }
            })
        })
        .catch((err) => {
          console.log('Fetch Error :-S', err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .LCoronaWidgetNew {
    background: url('https://img.lrytas.lt/coronawidget/bg.jpg') no-repeat center center / cover;
    background-color: #F6F6F6;
    margin: 32px auto;
    @media (max-width: 767px) {
      background: #F6F6F6;
    }
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 24px 0 18px;
      margin-bottom: 2px;
      @media (max-width: 767px) {
        padding: 18px 12px 0 12px;
        .LCoronaWidgetNew__button {
          display: none;
        }
      }
    }
    &__bottom {
      display: none;
      padding: 18px 0 6px 0;
      @media (max-width: 767px) {
        display: block;
        text-align: center;
      }
    }
    &__button {
      font-family: 'Open Sans', Arial, sans-serif;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 37px;
      border-radius: 7px;
      background: #B7ECF2;
      color: #000;
      padding: 0 32px;
      font-size: 12px;
      text-transform: uppercase;
      font-weight: 700;
      text-decoration: none;
      letter-spacing: 0px;
      box-shadow: 3px 3px 6px #0000006B;
      position: relative;
      &--mobile {
        margin: 0 auto;
        background: #F6F6F6;
        &:hover {
          background: darken(#F6F6F6, 3%);
        }
        &:active {
          background: darken(#F6F6F6, 5%);
        }
      }
      &:hover {
        background: darken(#B7ECF2, 3%);
      }
      &:active {
        background: darken(#B7ECF2, 5%);
      }
    }
    &__headline {
      font-size: 30px;
      line-height: 1;
      color: #333;
      font-family: 'Open Sans', Arial, sans-serif;
      font-weight: 700;
      @media (max-width: 767px) {
        display: block;
        font-size: 18px;
      }
    }
    &__row {
      display: flex;
      align-items: center;
      padding: 12px 24px 24px 18px;
      position: relative;
      @media (max-width: 767px) {
        padding: 12px;
        display: block;
      }
      &:nth-child(3):before {
        content: '';
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        position: absolute;
        background: #B7ECF2;
        opacity: 0.85;
      }
    }
    &__col {
      flex: 1;
      display: flex;
      align-items: center;
      position: relative;
      @media (max-width: 767px) {
        & + & {
          margin-top: 12px;
        }
      }
    }
    &__title {
      font-size: 14px;
      line-height: 19px;
      color: #333;
      font-family: 'Open Sans', Arial, sans-serif;
      font-weight: 700;
      flex: 2;
      @media (max-width: 767px) {
        flex: auto;
        flex-basis: 55%;
        max-width: 55%;
      }
    }
    &__number {
      font-size: 34px;
      line-height: 1;
      color: #333;
      font-family: 'Open Sans', Arial, sans-serif;
      font-weight: 700;
      flex: 3;
      @media (max-width: 767px) {
        display: block;
        font-size: 24px;
        flex: auto;
        flex-basis: 45%;
        max-width: 45%;
      }
      &--red {
        color: #E5202E;
      }
    }
  }
</style>
